function layout() {
  const ctxView = {
    model: "staff.shift",
    selectable: "multi",
    form_action: ["edit"],
    table_action: [],
    activeSearch: true,
    domain: [],
    fields: {
      shift_date: {
        type: "date",
        readOnly: false,
        // withChange:
      },
      employee: {
        type: "many2one",
        model: "company.employee",
      },
      section: {
        type: "many2one",
        model: "staff.section",
      },
      shift_kind: {
        type: "many2one",
        model: "staff.shift.kind",
      },
      enter_timestamp: {
        type: "datetime",
        formatString: "YYYY-MM-DD HH:mm",
        // readOnly: true,
      },
      exit_timestamp: {
        type: "datetime",
        formatString: "YYYY-MM-DD HH:mm",
        // withChange: onChangeChannel,
      },
    },
    form: [],
    list: [
      { name: "employee" },
      { name: "shift_kind" },
      { name: "section" },
      { name: "enter_timestamp" },
      { name: "exit_timestamp" },
    ],
  };

  return ctxView;
}

export { layout };
